// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"s7","imageWrapper":"s8","image":"s9","imageInCenter":"s-","ctaWrapper":"s_","copyright":"ta","rentalBadge":"tb","sideGradient":"tc","bottomGradient":"td"};